module.exports = __webpack_public_path__ + "img/versa.55bca24b.png";